import React, { useState, useEffect } from "react";
import "../../styles/back-top.css";

function BackTop() {
  const [backToTop, setBackToTop] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 15) {
        setBackToTop(true);
      } else{
        setBackToTop(false);
      }
    });
  }, []);

  const scrollUp = () =>{
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    })
  }
  return (
    <>
      {backToTop && (
        <i class="ri-arrow-up-line" id="button" onClick={scrollUp} />
      )}
    </>
  );
}

export default BackTop;
